<template>
  <div class="
    align-center
    flex
    h-full
    justify-center
    pt-52
    sm:pt-14
    sm:flex-col
    sm:justify-start
    sm:mb-14
    sm:px-4
  ">
    <img
      alt="Page Not Found"
      class="flex-grow-0
        flex-shrink-0
        h-[232px]
        mr-[120px]
        self-center
        sm:h-[186px]
        sm:mb-14
        sm:mx-auto
        sm:w-full
      "
      src="@/assets/images/page-not-working.svg"
    />
    <section class="self-center sm:w-full sm:text-center">
      <h1 class=" mb-6 sm:mb-8 sm:font-normal sm:text-2xl text-3.25xl text-border">
        網頁無法正常運作
      </h1>
      <p>
        發生錯誤，請稍後再試。
      </p>
      <w-button
        class="mt-16 px-16 py-3 sm:w-full"
        @click.prevent="goBack"
      >
        <span>
          重新載入
        </span>
      </w-button>
    </section>
  </div>
</template>

<script>
import NotWorking from './NotWorking';

export default NotWorking;
</script>
